import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { SiteHeader, SiteFooter } from "../components/dnh/SiteChrome";
import { LegacyDestination } from "../components/dnh/feed/LegacyDestination";
import { Hero } from "../components/dnh/home/Hero";
import { WorldFlashcards } from "../components/dnh/home/WorldFlashcards";
import { WhyTrust, Newsletter } from "../components/dnh/home/HomeExtras";
import { PlatformStatsCtx } from "../components/dnh/home/PlatformStatsContext";
import { getStats } from "../utils/api";

const HomeDiscovery = () => {
  const [data, setData] = useState(null), [error, setError] = useState(""), [retry, setRetry] = useState(0);
  const [stats, setStats] = useState(null);
  useEffect(() => { let active = true; getStats().then(value => { if (active) setStats(value); }).catch(() => {}); return () => { active = false; }; }, []);
  useEffect(() => { const abort = new AbortController(); setError(""); fetch(`${process.env.REACT_APP_BACKEND_URL}/api/home`, { signal: abort.signal }).then(r => r.ok ? r.json() : Promise.reject()).then(setData).catch(() => { if (!abort.signal.aborted) setError("The latest editions could not be loaded."); }); return () => abort.abort(); }, [retry]);
  return <PlatformStatsCtx.Provider value={stats}><div className="min-h-screen bg-[var(--paper)] text-[var(--ink)]" data-testid="home-page"><SiteHeader activeNav="Home" ticker />
    <main><Hero />
      <WorldFlashcards stories={data?.world_stories} error={error} retry={() => setRetry(n => n + 1)} />
      <WhyTrust /><Newsletter />
    </main><SiteFooter newsletterOnPage /></div></PlatformStatsCtx.Provider>;
};

export default function Home() {
  const [params] = useSearchParams();
  const legacy = ["view", "mode", "category", "country", "iso2", "state", "topic", "source", "source_types", "q", "page", "focus"].some(k => params.has(k));
  return legacy ? <LegacyDestination kind="latest" /> : <HomeDiscovery />;
}